import React, { useRef, useEffect } from 'react';
import { View, TextInput, FlatList, TouchableOpacity, Text, StyleSheet, ActivityIndicator } from 'react-native';
import BreadcrumbHeader from './BreadCrumbHeader';
import { Icons } from '@hmsexp/component-library';
import { isEqual } from 'lodash';
import { Platform } from 'react-native';
const Dropdown = ({
  options,
  selected,
  onSelect,
  search,
  setSearch,
  canGoBack,
  onGoBack,
  backText,
  autoFocus = true,
  isLoading = false
}) => {
  const inputRef = useRef(null);

  useEffect(() => {
    if (autoFocus && inputRef.current) {
      setTimeout(() => inputRef.current.focus(), 100);
    }
  }, [autoFocus]);

  const isItemOrChildSelected = item => {
    if (selected.some(s => isEqual(s.fullValue, item.fullValue))) return true;
    if (item.children) {
      return item.children.some(child => isItemOrChildSelected(child));
    }
    return false;
  };

  const renderItem = ({ item }) => {
    const isSelected = isItemOrChildSelected(item);
    const hasChildren = Array.isArray(item.children) && item.children.length > 0;

    return (
      <TouchableOpacity
        style={[styles.option, isSelected && styles.optionSelected]}
        activeOpacity={0.6}
        onPress={() => onSelect(item)}>
        <View style={styles.tickBox}>{isSelected && <Text style={styles.check}>✓</Text>}</View>
        <Text style={[styles.label, isSelected && styles.labelSelected]}>{item.label}</Text>
        <View style={styles.iconRow}>{hasChildren && <Text style={styles.childArrow}>›</Text>}</View>
      </TouchableOpacity>
    );
  };

  return (
    <View style={styles.dropdown}>
      {isLoading && (
        <View style={styles.loadingOverlay}>
          <ActivityIndicator color='#4e5dca' />
        </View>
      )}
      <View style={styles.searchContainer}>
        <TextInput
          ref={inputRef}
          placeholder='Search'
          value={search}
          onChangeText={setSearch}
          placeholderTextColor='#9CA3AF'
          style={[styles.searchInput, Platform.OS === 'web' && { outlineStyle: 'none' }]}
          autoFocus={autoFocus}
        />
        <View style={styles.iconContainer}>
          <Icons.SearchIcon width={16} height={16} color='#9CA3AF' />
        </View>
      </View>

      {canGoBack && <BreadcrumbHeader onGoBack={onGoBack} backText={backText} />}

      {options.length === 0 ? (
        <View style={styles.noResultsContainer}>
          <Text style={styles.noResultsText}>No filters found</Text>
        </View>
      ) : (
        <FlatList
          data={options}
          keyExtractor={item => item.fullValue || item.fullLabel}
          renderItem={renderItem}
          style={styles.list}
        />
      )}
    </View>
  );
};

export default Dropdown;

const styles = StyleSheet.create({
  dropdown: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    borderWidth: 1,
    borderColor: '#D1D5DB',
    marginTop: 6,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.08,
    shadowRadius: 8,
    elevation: 3,
    overflow: 'hidden'
  },
  loadingOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.6)',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 999
  },
  searchContainer: {
    position: 'relative',
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB',
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#FAFBFC'
  },
  searchInput: {
    flex: 1,
    paddingVertical: 10,
    paddingLeft: 14,
    paddingRight: 34,
    fontSize: 15,
    color: '#111827'
  },
  iconContainer: {
    position: 'absolute',
    right: 12,
    top: '50%',
    transform: [{ translateY: -8 }]
  },

  list: {
    maxHeight: 240
  },

  tickBox: {
    width: 20
  },

  option: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 10,
    paddingHorizontal: 16
  },
  optionSelected: {
    backgroundColor: '#EAF3FF'
  },
  label: {
    flex: 1,
    fontSize: 15,
    color: '#1B2438'
  },
  iconRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6
  },
  childArrow: {
    fontSize: 18,
    color: '#9CA3AF'
  },
  check: {
    fontSize: 16,
    color: '#2D77D0'
  },
  noResultsContainer: {
    paddingVertical: 20,
    alignItems: 'center',
    justifyContent: 'center'
  },
  noResultsText: {
    fontSize: 15,
    color: '#6B7280'
  }
});
